/* Home3 stays hidden until the owner approves it.

   The /home3 route mounts only when the build sets
   REACT_APP_HOME3_PREVIEW=true. Production builds leave it unset, so the route
   doesn't exist there: the router renders NotFound, nothing links to it, and
   it is not prerendered or in the sitemap.

   Run a local preview with the flag on, for example:
     set REACT_APP_HOME3_PREVIEW=true&& npm start
   Don't put the flag in .env or .env.local. */

export const isHome3PreviewEnabled = (env = process.env) => env.REACT_APP_HOME3_PREVIEW === 'true';

export const HOME3_PREVIEW_ENABLED = isHome3PreviewEnabled();
